import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
// TODO: Import required services for Foreign Keys
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { LevelService } from '../proxy/controlling/controllers/level.service';
import { ActivityMomentService } from '../proxy/controlling/controllers/activity-moment.service';
import { ActivityPlaceService } from '../proxy/controlling/controllers/activity-place.service';
import { ActivityReasonService } from '../proxy/controlling/controllers/activity-reason.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { ActivityToolService } from '../proxy/controlling/controllers/activity-tool.service';
import { SpacingTypeService } from '@planning/proxy/planning/controllers/spacing-type.service';
import { PlantationTypeService } from '@planning/proxy/planning/controllers/plantation-type.service';
import { FieldSituationService } from '@woodsecurity/proxy/wood-security/controllers/field-situation.service';
import { WorkTypeService } from '@general/proxy/general/controllers/work-type.service';

FieldBuilder.setNamespace('Controlling');

export const SILVICULTUREACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('applyDose', 'Entity.SilvicultureActivityParameter.ApplyDose')
    .build(),
  FieldBuilder
    .number('doses', 'Entity.SilvicultureActivityParameter.Doses')
    .dependsOn({
      when: { field: 'applyDose', operator: 'eq', value: true },
      then: { required: true },
      otherwise: { required: false },
    })
    .build(),
  FieldBuilder
    .number('operativeWidth', 'Entity.SilvicultureActivityParameter.OperativeWidth')
    .build(),
  FieldBuilder
    .checkbox('isRegrowth', 'Entity.SilvicultureActivityParameter.IsRegrowth')
    .build(),
  FieldBuilder
    .checkbox('applyNearbyPopulation', 'Entity.SilvicultureActivityParameter.ApplyNearbyPopulation')
    .build(),
  FieldBuilder
    .checkbox('applyExecutionWithRotationGreatherThanOne', 'Entity.SilvicultureActivityParameter.ApplyExecutionWithRotationGreatherThanOne')
    .build(),
  FieldBuilder
    .checkbox('isManual', 'Entity.SilvicultureActivityParameter.IsManual')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .display('name')
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('levelId', 'Entity.Level', LevelService)
    .displayFromNested('level.name')
    .sortBy('level.name') 
    .build(),
  FieldBuilder
    .foreignKey('activityMomentId', 'Entity.ActivityMoment', ActivityMomentService)
    .displayFromNested('activityMoment.name')
    .sortBy('activityMoment.name')
    .build(),
  FieldBuilder
    .foreignKey('activityPlaceId', 'Entity.ActivityPlace', ActivityPlaceService)
    .displayFromNested('activityPlace.name')
    .sortBy('activityPlace.name')
    .build(),
  FieldBuilder
    .foreignKey('activityReasonId', 'Entity.ActivityReason', ActivityReasonService)
    .displayFromNested('activityReason.name') 
    .sortBy('activityReason.name')
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
  FieldBuilder
    .foreignKey('activityToolId', 'Entity.ActivityTool', ActivityToolService)
    .displayFromNested('activityTool.name')
    .sortBy('activityTool.name')
    .build(),
  FieldBuilder
    .foreignKey('spacingTypeId', 'Entity.SpacingType', SpacingTypeService)
    .display('name') 
    .keyField('id') 
    .build(),
  FieldBuilder
    .foreignKey('plantationTypeId', 'Entity.SilvicultureActivityParameter.PlantationType', PlantationTypeService)
    .display('name')  
    .keyField('id')  
    .build(),
  FieldBuilder
    .foreignKey('fieldSituationId', 'Entity.FieldSituation', FieldSituationService)
    .display('name')  
    .keyField('id')  
    .build(),
  FieldBuilder
    .foreignKey('workTypeId', 'Entity.WorkType', WorkTypeService)
    .display('name') 
    .keyField('id')  
    .build(),
];

export const SILVICULTUREACTIVITYPARAMETER_CONFIG = {
  entityName: 'SilvicultureActivityParameter',
  localizationKey: 'Controlling::Entity.SilvicultureActivityParameter',
  fields: SILVICULTUREACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.SilvicultureActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
